// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xm_a bho_a bho_x","StrollerDetailRating__muted":"xm_b bho_fo"};